import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { Avatar, Box, Button, Typography } from '@mui/material'

import { Organization } from 'types/organization'

import { getAvatarInitials } from 'utils/avatar'

import { useMediaSize } from 'hooks/useMediaSize'

import OrganizationMainInfo from 'components/OrganizationMainInfo'

import s from './styles'

interface Props {
  organization: Organization
}

const OrganizationListItem: FC<Props> = ({ organization }) => {
  const navigate = useNavigate()
  const { isPhone } = useMediaSize()

  const handleViewOrganization = () => {
    navigate(organization.id)
  }

  return (
    <Box sx={s.container}>
      <Box sx={s.flexBox}>
        <Box sx={s.flexBox}>
          <Avatar alt="Avatar" src={''} sx={s.avatar}>
            <Typography variant="h2">{getAvatarInitials(organization.name)}</Typography>
          </Avatar>
          <Box>
            <Typography variant="h3">{organization.name}</Typography>
            <Box sx={s.organizationMainInfoContainer}>
              <OrganizationMainInfo organization={organization} />
            </Box>
          </Box>
        </Box>
      </Box>

      <Button
        fullWidth={isPhone}
        variant="outlined"
        size="small"
        sx={s.viewButton}
        onClick={handleViewOrganization}
      >
        View
      </Button>
    </Box>
  )
}

export default OrganizationListItem
